module.exports = __webpack_public_path__ + "img/accounting.fbfdfd29.svg";